/* eslint-disable */
import { createApp } from "vue";
import App from "./App.vue";
import base from "./base/base";
import router from "./router";

import VueCookies from "vue-cookies";
import Notifications from "@kyvg/vue3-notification";
import VueLazyload from "vue3-lazyload";
import "./registerServiceWorker";

const app = createApp(App);

app.provide("base", base);

app.config.devtools = false;
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};

  app.config.errorHandler = (error, instance, info) => {};

  app.config.warnHandler = (message, instance, trace) => {};
}

router.beforeEach((to) => {
  const { title, description } = to.meta;
  document.title = title || "آتیه ایرانیان";
  const descriptionElement = document.querySelector(
    'head meta[name="description"]'
  );
  if (descriptionElement)
    descriptionElement.setAttribute("content", description || "");

  if (
    [
      "www.atiyacrowd.ir",
      "atiyacrowd.ir",
      "www.atiyehiraniancf.com",
      "www.atiyehiraniancf.ir",
      "atiyehiraniancf.ir",
      "atiya.me",
    ].includes(window.location.hostname)
  )
    window.location.href = "https://atiyehiraniancf.com" + to.fullPath;
});

app.use(router).use(VueCookies).use(Notifications).use(VueLazyload, {
  loading: "",
  error: "",
  attempt: 1,
});

app.mount("#app");
